import React, { useState, useEffect, useMemo, useCallback } from 'react';
import get from 'lodash/get';
import { Search } from '@yme/assets/icons';
import { buildKey } from '@yme/common/index';
import { keyCodes } from '@yme/utils/constants';
import { ControlPanel } from './ControlPanel';
import { InputStyled } from './styled';
const SEARCH_FIELD_NAME = 'searchField';
export function SearchInput(props) {
    const { isRightToLeft = false, dataTestId = 'default', leftSideIconType = Search, isDisabled = false, isLabelVisible = true, label = '', placeholder = '', inputValue = '', setInputValue, className, hasFilters = true, } = props;
    const [currentValue, setCurrentValue] = useState(inputValue);
    useEffect(() => {
        setCurrentValue(inputValue);
    }, [inputValue]);
    const onClear = useCallback(() => {
        setInputValue('');
        setCurrentValue('');
    }, [setInputValue]);
    const Controls = useMemo(() => (React.createElement(ControlPanel, { onClick: onClear, isRightToLeft: isRightToLeft })), [isRightToLeft, onClear]);
    const onKeyDownHandlerHandler = useCallback((event) => {
        const value = get(event, 'target.value', '');
        if (setInputValue && event.key === keyCodes.ENTER) {
            setInputValue(value.trim());
        }
    }, [setInputValue]);
    const finalDataTestId = buildKey('SearchInput', dataTestId);
    return (React.createElement(InputStyled, { type: "text", placeholder: placeholder, name: SEARCH_FIELD_NAME, id: SEARCH_FIELD_NAME, leftIcon: leftSideIconType, changeHandler: setCurrentValue, dataTestId: finalDataTestId, value: currentValue, label: label, isLabelVisible: isLabelVisible, isRightToLeft: isRightToLeft, isDisabled: isDisabled, className: className, multipleIconsBlock: currentValue.length > 0 ? Controls : null, hasFilters: hasFilters, onKeyDownHandler: onKeyDownHandlerHandler }));
}
SearchInput.displayName = 'SearchInput_Atom';
